import React from "react";
import { UseCases } from "@planzone/core";
import { RequestedView } from "./types";

const Context = React.createContext<{
  views: RequestedView[];
  pushView(view: RequestedView): void;
}>({
  views: [],
  pushView(view: RequestedView) {},
});

function useModal() {
  return React.useContext(Context);
}

function useViews() {
  const [views, setViews] = React.useState<RequestedView[]>([]);
  const remove = (views: RequestedView[], key: UseCases) =>
    views.filter((view) => view.key !== key);
  const removeView = (key: UseCases) => setViews((views) => remove(views, key));
  const pushView = (view: RequestedView) =>
    setViews((state) => [...remove(state, view.key), view]);

  return { views, removeView, pushView };
}

export { useModal, useViews, Context };
